module.exports = __webpack_public_path__ + "img/aircon_install.0769c1e4.png";